/* eslint-disable prettier/prettier */
export const CubeBackground = () => {
  const colorClasses = ['bg-secondary', 'bg-muted'];
  const columns = 10;
  const rows = 5;
  const spacingX = 100 / columns;
  const spacingY = 100 / rows;

  const cubes = [];

  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < columns; col++) {
      const size = Math.floor(Math.random() * 20) + 50;
      const top = row * spacingY + Math.random() * (spacingY - 2);
      const left = col * spacingX + Math.random() * (spacingX - 2);
      const bgColorClass = colorClasses[Math.floor(Math.random() * colorClasses.length)];

      cubes.push(
        <div
          key={`${row}-${col}`}
          className={`absolute rounded-sm opacity-20 transition-all duration-500 ${bgColorClass}`}
          style={{
            width: `${size}px`,
            height: `${size}px`,
            top: `${top}%`,
            left: `${left}%`,
          }}
        />,
      );
    }
  }

  return <div className="absolute top-0 left-0 z-0 w-full h-full overflow-hidden">{cubes}</div>;
};
